export default __webpack_public_path__ + "static/media/section2-img2.89093883.png";